import { Alert, Modal, Space, Typography } from 'antd';

export interface MailboxCreationResponse {
  result?: {
    success?: boolean;
    employeeEmail?: string;
    aliMail?: { success?: boolean; mode?: string; existed?: boolean };
  };
  credentials?: { employeeEmail: string; initialPassword: string };
}

export function MailboxCreationDialog({
  response,
  onClose
}: {
  response?: MailboxCreationResponse;
  onClose: () => void;
}) {
  if (!response) return null;
  return (
    <Modal
      open
      title="邮箱开通结果"
      onOk={onClose}
      onCancel={onClose}
      okText="我知道了"
      cancelButtonProps={{ style: { display: 'none' } }}
      maskClosable={false}
      keyboard={false}
      width={560}
    >
      <MailboxCreationResult {...response} />
    </Modal>
  );
}

export function MailboxCreationResult({ result, credentials }: MailboxCreationResponse) {
  const mailbox = result?.aliMail;
  const created = mailbox?.mode === 'api' && mailbox.success && !mailbox.existed;
  const password = created ? credentials?.initialPassword : undefined;
  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Typography.Text>邮箱：{result?.employeeEmail || '未返回邮箱地址'}</Typography.Text>
      {password ? (
        <>
          <Typography.Text>
            邮箱初始密码：
            <Typography.Text code copyable>
              {password}
            </Typography.Text>
          </Typography.Text>
          <Typography.Text type="secondary">
            初始密码仅本次展示，关闭后不再提供；请妥善保管，并在首次登录时修改。
          </Typography.Text>
        </>
      ) : (
        <Alert
          type="info"
          message={
            mailbox?.existed
              ? '邮箱已存在，未重置密码；无法读取已有邮箱的初始密码。'
              : '未取得新邮箱的初始密码，不能确认已完成真实邮箱创建。'
          }
        />
      )}
      {result?.success === false && password && (
        <Alert type="warning" message="邮箱已创建，但钉钉绑定未完成。请保管上述密码，处理绑定失败后再重试。" />
      )}
      <Alert
        type="warning"
        message="短信发送未确认"
        description="本系统没有密码短信的发送回执，不能确认员工已收到。邮箱 API 创建或通讯录字段更新不等同于钉钉后台窗口的自动短信通知。"
      />
    </Space>
  );
}
